/*
 * @Author: Xin Zhao
 * @Date: 2021-01-12 17:24:42
 * @LastEditTime: 2021-01-28 11:04:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \CoreWeb\packages\ui\src\components\leftSelect.ts
 */
import { BaseVue, Component, Prop,Watch } from "@newview/base-web";
import { ApiResult, BaseApi } from "@newview/infrastructure";
import { toolBar } from "@newview/ui";
///需要传入的参数
class SelectOption {
  Title = "";//标题
  Api!: BaseApi;//查询所需的API-默认调用GetEntitiesDynamic方法
  TextName = ""; //用于显示的字段
  ValueName = "Id";//主键/在下一列表获取数据时需要使用的字段

  NextQueryName = "PId";//在下一个列表获取数据时对应的查询字段

  IsMain?: boolean = false;//是否主要显示的列表

  GetBefoerAll?: boolean = false; //是否获取之前所有的选择信息作为查询条件

  BeforeQuery?: (SelectEntityList: any[]) => string //在获取数据前
  CustomQuery?: (api: any, SelectEntityList: any[],filter:string) => Promise<ApiResult> //自定义查询
  AfterQuery?: (api: any[]) => [] //在获取数据后

  DataList: any[] = []//筛选后的数据
  TDataList: any[] = []//查询到的数据
  OnSelect?: (SelectEntity: any,SelectEntitys:any[]) => void //选择时

  BeforeLink?: () => number[] //关联的下一个列表Index

  SelectEntity?: any //已选择的数据
  SelectModel={} //关联组件的实体
  private Convert(params: object) {
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        this[key] = params[key];
      }
    }
  }
}




@Component({
  components: { toolBar },
})
export default class leftSelect extends BaseVue {
  @Prop({ default: () => ([]) })
  selectOptions!: SelectOption[];
  @Prop({ default: () => ([]) })
  footerBtnList!: any[];

  NotMains:any[]=[]
  Mains:any[]=[]

  searchText = ""
  numberxx=0
  
  async initConfig() {
    for (let index = 0; index < this.selectOptions.length; index++) {
      const element = this.selectOptions[index];
      await this.loadData(element,index,this.selectOptions)
    }
  }


  async loadData(option: SelectOption, index: number,items:SelectOption[],isInit=true) {
    let _this = this,
      apiResult: ApiResult,
      filter: string = " 1=1 ";
      option.SelectModel={}
      option.SelectEntity = {}
    let SelectEntitys = this.Baselinq.from(items).select((x) =>  { 
      return {SelectEntity:x.SelectEntity,NextQueryName:x.NextQueryName,ValueName:x.ValueName }
    }).toArray()

    if (option.BeforeQuery) {
      filter = option.BeforeQuery(SelectEntitys)
    } else {

     let afitem= items.filter((item, iindex) => { return option.GetBefoerAll ? iindex < index  : iindex == index - 1 })
     afitem.forEach((item) => {
        if (item.SelectEntity) {
          filter += ` AND ${item.NextQueryName} = '${item.SelectEntity[item.ValueName]}' `;
        }
      })
      if(afitem.length==1&&!afitem[0].SelectEntity){
          filter = '1>1'
      }
    }

    if (option.CustomQuery) {

       apiResult = await option.CustomQuery(option.Api, SelectEntitys,filter)
    } else {
       apiResult = await option.Api.getEntitiesDynamic(" * ", filter)
    }
    
      if (apiResult.issucess) {
        option.TDataList=[]
        if (option.AfterQuery) {
          option.TDataList = option.AfterQuery(apiResult.result)
        } else {
          option.TDataList = apiResult.result
        }
        option.DataList=[]
        if (option.IsMain) {
          option.DataList = this.GetTreeData(option.TDataList, option.TextName)
        } else {
          option.DataList = option.TDataList
        }
        
        if (option.DataList.length>0) {
          if(option.IsMain){
              option.DataList[0].selected= true
          }else{
              option.SelectModel = option.DataList[0][option.ValueName]
          }
          option.SelectEntity = option.DataList[0]
        }
        if(isInit){
          if(option.IsMain){
            this.Mains.push(option)
          }else{
            this.NotMains.push(option)
          }
        }
        this.SelectActive(option,SelectEntitys)
        this.numberxx++;
        let title =option.Title;
        option.Title= option.Title+this.numberxx
        option.Title=title;
      }
  }

  handleSearch(option: SelectOption) {
    option.DataList = option.TDataList.filter(x => x[option.TextName].indexOf(this.searchText) > -1)
  }

  //触发方法
  SelectHandler(event, option:SelectOption,optionIndex:number) {
    
    let NextOptionIndex=Array.from(this.selectOptions.keys()).filter(x=>x>optionIndex),NextFlg=true;
    if (option.BeforeLink) {
      NextOptionIndex= option.BeforeLink();
    }
    if (option.IsMain) {
      option.SelectEntity=event[0]
      NextFlg=false;
    }else{
      option.SelectEntity=option.DataList.find(x=>x[option.ValueName]==event["value"]&&x[option.TextName]==event["label"])
    }

    let SelectEntitys = this.Baselinq.from(this.NotMains).select((x) =>  { 
      return {SelectEntity:x.SelectEntity,NextQueryName:x.NextQueryName,ValueName:x.ValueName }
    }).toArray()

    this.SelectActive(option,SelectEntitys)
    
    if (NextFlg) {
     // this.FindNextOption(NextOptionIndex)
    }
  }
  async SelectActive(option:SelectOption,ses:any[]){
    if (option.OnSelect) {
      option.OnSelect(option.SelectEntity,ses)
    }
  }
  


  @Watch("selectOptions") 
 async selOptionChange(newV,oldV){
    console.log(newV);
    this.Mains=[];
    this.NotMains=[];
    for (let index = 0; index < newV.length; index++) {
      const element = newV[index];
      await this.loadData(element,index,newV)
    }
  }
  //刷新
  refresh() {
    this.Mains=[];
    this.NotMains=[];
    this.initConfig();
  }
  //初始化
  mounted() {
    this.footerBtnList = [
      {
        name: "刷新",
        clickEvent: () => {
          this.refresh();
        },
        icon: "md-refresh",
        code: "refresh",
        tag: "refreshRoot",
      },
    ]
    this.initConfig()
  }
  /**
   * 获取树状数据
   * @param data 要转换的数据
   * @param valName 显示对应的键名
   * @param showName 显示使用的键名
   * @param idName 主键
   * @param pIdName 父主键
   */
  GetTreeData(data:any[],valName:string,showName="title",idName="Id",pIdName="PId"){
   
    const map = {};
    const val:any[] = [];
    
		data.forEach((item) => {
		    map[item[idName]] = item;
		});
		data.forEach((item) => {
        item[showName]=item[valName]
		    const parent:any = map[item[pIdName]];
		    if (parent) {
		        (parent.children || (parent.children = [])).push(item);
		    } else {
		        val.push(item);
		    }
    });
    return val;
  }
}
